'use client';
import React, { useEffect } from 'react';
import { Box, Grid, GridItem, FormLabel, Input } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleUser,
  faBuildings,
  faEnvelope,
  faPhone,
} from '@fortawesome/pro-solid-svg-icons';

import { useSelector, useDispatch } from 'react-redux';
import {
  setName,
  setEmail,
  setCompany,
  setTel,
} from '@/app/redux/slices/configBasketSlice';
import './summary.css';
import { setStateValue } from '@/app/redux/slices/configGymSlice';

export default function Contact({ formik }) {
  const dispatch = useDispatch();
  const fullName = useSelector((state) => state.basket.customerData.fullName);
  const companyName = useSelector(
    (state) => state.basket.customerData.companyName
  );
  const email = useSelector((state) => state.basket.customerData.email);
  const phone = useSelector((state) => state.basket.customerData.phone);
  const isMobile = useSelector((state) => state.gym.isMobile);
  const delAddError = useSelector((state) => state.site.DelAddError);
  const billAddError = useSelector((state) => state.site.BillAddError);
  // Define a custom change handler
  const handleCustomChange = (e) => {
    // console.log('Handle Change Fired');
    // Call Formik's handleChange
    formik.handleChange(e);

    // Dispatch actions to Redux store
    const { name, value } = e.target;
    switch (name) {
      case 'fullName':
        dispatch(setName(value));
        break;
      case 'email':
        dispatch(setEmail(value));
        break;
      case 'phone':
        dispatch(setTel(value));
        break;
      case 'companyName':
        dispatch(setCompany(value));
        break;
      default:
        // No additional action
        break;
    }
  };

  const isFormValid =
    formik.isValid &&
    !formik.errors.fullName &&
    !formik.errors.email &&
    !formik.errors.phone;

  const formInput = {
    backgroundColor: 'white',
    borderRadius: { base: '6vw', md: '3vw' },
    border: 'solid 1px #00000030',
    _placeholder: {
      color: '#00000050',
    },
    margin: { base: '2vw 0', md: '0' },
    padding: { base: '6vw 4vw', md: '0.8vw 1.5vw' },
  };
  const errorStyle = {
    height: '1.5vw',
    width: '100%',
    color: 'red',
    fontSize: '0.8vw',
    display: 'flex',
    justifyContent: 'end',
  };
  useEffect(() => {
    const isValid = formik.isValid && delAddError && billAddError;
    dispatch(setStateValue({ key: 'isCheckoutValid', value: isValid }));
  }, [formik.isValid, delAddError, billAddError, dispatch]);

  //console.log('Formik Values:', formik.values);
  //console.log('Formik Errors:', formik.errors);
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid
          templateColumns={{ base: '1fr', md: '1fr 1fr' }}
          columnGap="20px"
          padding="2vw 2vw 0"
        >
          <GridItem>
            <FormLabel
              className="formLabel"
              mb="0"
              display="flex"
              alignItems="center"
            >
              <FontAwesomeIcon
                className="formIcon"
                icon={faCircleUser}
                style={{ marginRight: '8px' }}
              />
              Full Name
            </FormLabel>
            <Input
              {...formInput}
              name="fullName"
              value={formik.values.fullName}
              onChange={handleCustomChange}
              onBlur={formik.handleBlur}
              placeholder="Enter your full name"
            />
            <Box {...errorStyle} mt="1">
              {formik.touched.fullName && formik.errors.fullName && (
                <div>{formik.errors.fullName}</div>
              )}
            </Box>
          </GridItem>

          <GridItem>
            <FormLabel
              className="formLabel"
              mb="0"
              display="flex"
              alignItems="center"
            >
              <FontAwesomeIcon
                className="formIcon"
                icon={faBuildings}
                style={{ marginRight: '8px' }}
              />
              Company Name
            </FormLabel>
            <Input
              {...formInput}
              name="companyName"
              value={formik.values.companyName}
              onChange={handleCustomChange}
              onBlur={formik.handleBlur}
              placeholder="If applicable"
            />
            <Box {...errorStyle} mt="1">
              {formik.touched.companyName && formik.errors.companyName && (
                <div>{formik.errors.companyName}</div>
              )}
            </Box>
          </GridItem>

          <GridItem>
            <FormLabel
              className="formLabel"
              mb="0"
              display="flex"
              alignItems="center"
            >
              <FontAwesomeIcon
                className="formIcon"
                icon={faEnvelope}
                style={{ marginRight: '8px' }}
              />
              Email
            </FormLabel>
            <Input
              {...formInput}
              name="email"
              value={formik.values.email}
              onChange={handleCustomChange}
              onBlur={formik.handleBlur}
              placeholder="Enter your email"
            />
            <Box {...errorStyle} mt="1">
              {formik.touched.email && formik.errors.email && (
                <div>{formik.errors.email}</div>
              )}
            </Box>
          </GridItem>

          <GridItem>
            <FormLabel
              className="formLabel"
              mb="0"
              display="flex"
              alignItems="center"
            >
              <FontAwesomeIcon
                className="formIcon"
                icon={faPhone}
                style={{ marginRight: '8px' }}
              />
              Phone
            </FormLabel>
            <Input
              {...formInput}
              name="phone"
              value={formik.values.phone}
              onChange={handleCustomChange}
              onBlur={formik.handleBlur}
              placeholder="Enter your phone number"
            />
            <Box {...errorStyle} mt="1">
              {formik.touched.phone && formik.errors.phone && (
                <div>{formik.errors.phone}</div>
              )}
            </Box>
          </GridItem>
        </Grid>
      </form>
    </>
  );
}
